import { SceneManager } from "pixi-scenegraph";
import { WIDTH, HEIGHT } from '@/constants';
import game from "@/model/game";
import { ErrorScene } from "@/scenes/error-scene";
import { FailScene } from "@/scenes/fail-scene";
import { GameScene } from "@/scenes/game-scene";
import { MenuScene } from "@/scenes/menu-scene";
import { ResultsScene } from "@/scenes/results-scene";
import { SelectModeScene } from "@/scenes/select-mode-scene";
import { SelectSongScene } from "@/scenes/select-song-scene";
import { SettingsScene } from "@/scenes/settings-scene";
import { GameScene2D } from "@/scenes/game-scene-2d";
import { GameScene3D } from "@/scenes/game-scene-3d";
import { PracticeModeSettingsScene } from "@/scenes/practice-mode-settings-scene";
import { OptionsScene } from "@/scenes/options-scene";
import { MenuDemoScene } from "@/scenes/menu-demo"
const options = {
    width: WIDTH,
    height: HEIGHT,
    view: document.querySelector('canvas#pixi'),
    antialias: true,
    autoDensity: true,
    resolution: 1
};

const scm = new SceneManager(options);

export async function activateScene(sceneName, payload) {
    const nextScene = scm.GetScene(sceneName);
    if (nextScene && typeof nextScene.setPayload === 'function' && payload) {
        // todo: set loading indicator
        await nextScene.setPayload(payload);
    }
    if (typeof nextScene.onReveal === 'function') {
        nextScene.onReveal();
    }
    scm.ActivateScene(sceneName);
}

export function resetGameScene() {
    const oldScene = scm.GetScene(game.mode);
    oldScene.destroy();
    scm.RemoveScene(oldScene);
    switch (game.mode) {
        case "game-2d": scm.AddScene(new GameScene2D());
            break;
        case "game-notation": scm.AddScene(new GameScene());
            break;
        case "game-3d": scm.AddScene(new GameScene3D());
        break;
        default: {
            throw new Error('can not reset game.mode ' + game.mode);
        }
    }
}

export function getCurrentSceneName() {
    return scm.CurrentScene.Name;
}

scm.app.renderer.resize(WIDTH, HEIGHT);

// countDrawCalls(scm.app);
// cull(scm.app);

export async function startGame() {
    scm.AddScene(new MenuDemoScene());
    // scm.AddScene(new MenuScene());
    scm.AddScene(new SelectSongScene());
    scm.AddScene(new GameScene());
    // scm.AddScene(new GameScene2D());
    // scm.AddScene(new GameScene3D());
    scm.AddScene(new ResultsScene());
    scm.AddScene(new FailScene());
    scm.AddScene(new ErrorScene());
    // scm.AddScene(new SettingsScene());
    scm.AddScene(new SelectModeScene());
    // scm.AddScene(new PracticeModeSettingsScene());
    // scm.AddScene(new OptionsScene());
    activateScene('menu-demo');
    // activateScene('error', new TypeError('Error shmerror'));

    // const SONG = {
    //     mxlUrl: '/public/xml/Hark_the_Herald_Angels_Sing.mxl'
    // };
    // const MODE = 'game-3d';
    // game.practiceMode = true;
    // game.practiceModeTempoPercent = 75;
    // game.practiceModeStops = true;
    // game.mode = MODE;
    // game.song = SONG;
    // await scm.GetScene(MODE).setPayload(SONG)
    // activateScene(MODE);
}

export const pixiRenderer = scm.app.renderer;